import { render, staticRenderFns } from "./EditDelivery.vue?vue&type=template&id=77b8680c&scoped=true&"
import script from "./EditDelivery.vue?vue&type=script&lang=ts&"
export * from "./EditDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./EditDelivery.vue?vue&type=style&index=0&id=77b8680c&lang=scss&scoped=true&"
import style1 from "./EditDelivery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b8680c",
  null
  
)

export default component.exports